/* eslint-disable prettier/prettier, react/prop-types, import/no-cycle */
import { ExclamationCircleFilled, InboxOutlined } from '@ant-design/icons';
import { Alert, Card, Checkbox, Col, DatePicker, Form, Input, Modal, Radio, Row, Select, Spin, Typography, Upload, notification } from "antd";
import AWS from 'aws-sdk';
import axios from "axios";
import moment from "moment";
import React, { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "../../components/buttons/buttons";
import { PageHeader } from "../../components/page-headers/page-headers";
import { DataRead as GetAgents } from "../../redux/agents/actionCreator";
import { DataRead as GetCompany } from "../../redux/companies/actionCreator";
import { DataRead as GetCountry } from "../../redux/countries/actionCreator";
import { GetVendorEng as GetEngineers } from "../../redux/engineers/actionCreator";
import { DataRead as GetJobDescription } from "../../redux/jobDescription/actionCreator";
import { cancelJob, createJob, getJobById, updateJob } from "../../redux/jobs/actionCreator";
import { DataRead as GetSpares } from "../../redux/spares/actionCreator";
import { AppRoutes } from "../../routes/routes";
import { AddEditAgents } from "../agents/addEdit";
import { AddEditCompany } from "../companies/addEdit";
import { AddEditEngineer } from "../engineers/addEdit";
import { AddEditjobDescription } from "../jobDescriptions/addEdit";
import { AddEditSpares } from "../spares/addEdit";
import { AddEditCountries } from "../countries/addEdit";

const { confirm } = Modal;

const S3_BUCKET = "thawemarineae-job-attachments";
const REGION = "ap-south-1";

export const logisticCondition = ["Singapore", "singapore", "SINGAPORE", "Malaysia", "MALAYSIA", "malaysia"]

export const JobCountries = [
    { id: "OMAN", value: "OMAN", label: "OMAN" },
    { id: "UAE", value: "UAE", label: "UAE" },
    { id: "BAHRAIN", value: "BAHRAIN", label: "BAHRAIN" },
    { id: "QATAR", value: "QATAR", label: "QATAR" },
    { id: "SAUDI ARABIA", value: "SAUDI ARABIA", label: "SAUDI ARABIA" },
    { id: "SUEZ", value: "SUEZ", label: "SUEZ" },
    { id: "KUWAIT", value: "KUWAIT", label: "KUWAIT" },
]

const config = {
    bucketName: S3_BUCKET,
    dirName: "attachements",
    region: REGION,
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
}

export function AddEditJob() {

    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { state } = useLocation();
    const [searchParams] = useSearchParams();
    const { loading, error, getJob, getJobLoading, getJobErr, cancelJobLoading } = useSelector(store => store.jobs);
    const jobDescription = useSelector(store => store.jobDescription);
    const engineers = useSelector(store => store.engineer);
    const company = useSelector(store => store.company);
    const country = useSelector(store => store.country);
    const spares = useSelector(store => store.spares);
    const agents = useSelector(store => store.agents);
    const isJobCompleted = Form.useWatch('isJobCompleted', form);
    const quotationDate = Form.useWatch('quotationDate', form);
    const poNumber = Form.useWatch('poNumber', form);
    const roleId = useSelector((store) => store.auth.loginData?.role_id ?? 0);

    const [modal, setModal] = useState({ open: false, component: <></>, variant: "" });
    const [followUpReq, updateFollowupRequired] = useState("false")

    const jobId = searchParams.get('id');
    const [reload, setReload] = useState(false);
    const isEdit = jobId;

    const fetchMasters = () => {
        dispatch(GetCompany())
        dispatch(GetEngineers())
        dispatch(GetJobDescription())
        dispatch(GetSpares())
        dispatch(GetAgents())
        dispatch(GetCountry())
    }

    const showModal = (component = <></>, variant = "") => {
        setModal({ ...modal, open: true, component, variant });
    };

    const handleOk = () => {
        fetchMasters();
        setModal({ ...modal, open: false, component: <></>, variant: "" });
    };

    const handleCancel = () => {
        setModal({ ...modal, open: false, component: <></>, variant: "" });
    };

    const giveMeUpdatePayload = (values) => {
        const payload = {
            ...values,
            jobId,
            isFollowupReq: values.isFollowupReq === "true",
            serviceReport: JSON.stringify(values?.serviceReport?.map(_ => _?.response) ?? []),
            vdcCocReport: JSON.stringify(values?.vdcCocReport?.map(_ => _?.response) ?? []),
            generalNoteAttachments: values?.generalNoteAttachments ? JSON.stringify(values?.generalNoteAttachments?.map(_ => _?.response) ?? []) : undefined,
            logisticNoteAttachments: values?.logisticNoteAttachments ? JSON.stringify(values?.logisticNoteAttachments?.map(_ => _?.response) ?? []) : undefined,
            engineerNoteAttachments: values?.engineerNoteAttachments ? JSON.stringify(values?.engineerNoteAttachments?.map(_ => _?.response) ?? []) : undefined,
            invoice: values?.invoice ? JSON.stringify(values?.invoice?.map(_ => _?.response) ?? []) : undefined,
            queryReceivedOn: values.queryReceivedOn ? values.queryReceivedOn.startOf('day') : "",
            quotationDate: values.quotationDate ? values.quotationDate.startOf('day') : "",
            vesselETA: values.vesselETA ? values.vesselETA.startOf('day') : "",
            completionDate: values.completionDate ? values.completionDate.startOf('day') : "",
            nextAttendDate: values.nextAttendDate ? values.nextAttendDate.startOf('day') : "",
            invoiceDate: values.invoiceDate ? values.invoiceDate.startOf('day') : "",
        }
        if (roleId === 3) {
            payload.queryReceivedOn = getJob.queryReceivedOn ? moment(getJob.queryReceivedOn).toISOString() : null;
            payload.quotationDate = getJob.quotationDate ? moment(getJob.quotationDate).toISOString() : null;
            payload.setReminder = getJob.setReminder;
            payload.poNumber = getJob.poNumber;
            payload.isJobCompleted = getJob.isJobCompleted;
            payload.completionDate = getJob.completionDate ? moment(getJob.completionDate).toISOString() : null;
            payload.isServiceReportSent = getJob.isServiceReportSent;
            payload.invoiceDate = getJob.invoiceDate ? moment(getJob.invoiceDate).toISOString() : null;
            payload.boxVesselClass = getJob.boxVesselClass;
            payload.equipmentDetail = getJob.equipmentDetail;
            payload.generalNote = getJob.generalNote;
            payload.isFollowupReq = getJob.isFollowupReq;
            payload.nextAttendDate = getJob.nextAttendDate ? moment(getJob.nextAttendDate).toISOString() : null;
        }
        return payload;
    }

    const handleSubmit = async (values) => {
        if (sessionStorage.getItem('isUploading')?.toString() === '1') {
            notification.warning({
                message: "File upload in progress, please wait."
            })
            return false;
        };

        if (isEdit) {
            dispatch(updateJob(giveMeUpdatePayload(values), () => false))
        } else {
            dispatch(createJob(values, () => {
                navigate(`${AppRoutes.liveJobs}/${values.quotationDate ? "quoted" : "query"}`)
            }))
        }
    }

    const getInitialState = () => {
        return { country_id: "" };
    }

    const normFile = (e) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e?.fileList;
    };

    const onCancelJob = () => {
        if (sessionStorage.getItem('isUploading')?.toString() === '1') {
            notification.warning({
                message: "File upload in progress, please wait."
            })
        } else {
            confirm({
                title: 'Are you sure cancel this Job?',
                icon: <ExclamationCircleFilled />,
                okText: 'Yes',
                okType: 'danger',
                cancelText: 'No',
                onOk() {
                    dispatch(cancelJob(getJob.id, () => {
                        navigate(`${AppRoutes.liveJobs}/liveJobs`)
                    }))
                },
                onCancel() {
                    return false;
                },
            });
        }
    };

    const onFileUpload = async ({ file, onError, onProgress, onSuccess, }) => {
        sessionStorage.setItem('isUploading', 1);
        onProgress({ percent: 50 }, file);
        // Configure AWS SDK with your credentials
        AWS.config.update({
            accessKeyId: config.accessKeyId,
            secretAccessKey: config.secretAccessKey,
            region: config.region, // Replace with your S3 bucket's region
        });

        const s3 = new AWS.S3();

        const params = {
            Bucket: config.bucketName, // Replace with your S3 bucket name
            Key: `${file.name}`.replace(/#/g, '_'),
            Expires: 60 * 60,
        };

        try {
            // Upload the file to S3 bucket
            const securedUrl = await s3.getSignedUrlPromise("putObject", params);
            onProgress({ percent: 75 }, file);

            await axios({
                url: securedUrl,
                method: "put",
                headers: { 'Content-Type': file.type },
                data: file
            });

            onSuccess(`https://${params.Bucket}.s3.ap-south-1.amazonaws.com/${params.Key}`, file);
        } catch (err) {
            onError();
        } finally {
            sessionStorage.setItem('isUploading', 0);
        }
    }

    const updateFields = () => {
        form.resetFields();
        form.setFieldsValue({
            ...getJob,
            engineers: getJob?.mapJobEngineersByJobId?.nodes?.map(_ => _.engineerId) ?? [],
            descriptions: getJob?.mapJobDescriptionsByJobId?.nodes?.map(_ => _.descriptionId) ?? [],
            spares: getJob?.spares ? getJob?.spares : getJob?.mapJobSparesByJobId?.nodes?.map(_ => _?.masterSpareBySpareId?.name ?? "")?.join(",") ?? [],
            agents: getJob.agentId,
            spareVerified: getJob.sparesVerified,
            sparePrepare: getJob.sparesPrepare,
            queryReceivedOn: getJob.queryReceivedOn ? moment.utc(getJob.queryReceivedOn).local() : "",
            quotationDate: getJob.quotationDate ? moment.utc(getJob.quotationDate).local() : "",
            vesselETA: getJob.vesselETA ? moment.utc(getJob.vesselETA).local() : "",
            completionDate: getJob.completionDate ? moment.utc(getJob.completionDate).local() : "",
            nextAttendDate: getJob.nextAttendDate ? moment.utc(getJob.nextAttendDate).local() : "",
            invoiceDate: getJob.invoiceDate ? moment.utc(getJob.invoiceDate).local() : "",
            serviceReport: JSON.parse(getJob?.serviceReport ?? "[]")?.map((serviceReport, index) => {
                return {
                    uid: index + 1,
                    name: serviceReport?.split("/")?.pop()?.replace(/(%[0-9A-Fa-f]{2})+/g, "_") ?? "File",
                    status: 'done',
                    url: serviceReport,
                    response: serviceReport
                }
            }) ?? [],
            vdcCocReport: getJob.vdcCocReport ? JSON.parse(getJob?.vdcCocReport ?? "[]")?.map((vdcCocReport, index) => {
                return {
                    uid: index + 1,
                    name: vdcCocReport?.split("/")?.pop()?.replace(/(%[0-9A-Fa-f]{2})+/g, "_") ?? "File",
                    status: 'done',
                    url: vdcCocReport,
                    response: vdcCocReport
                }
            }) ?? [] : [],
            engineerNoteAttachments: getJob.engineerNoteAttachments ? JSON.parse(getJob?.engineerNoteAttachments ?? "[]")?.map((engineerNoteAttachments, index) => {
                return {
                    uid: index + 1,
                    name: engineerNoteAttachments?.split("/")?.pop()?.replace(/(%[0-9A-Fa-f]{2})+/g, "_") ?? "File",
                    status: 'done',
                    url: engineerNoteAttachments,
                    response: engineerNoteAttachments
                }
            }) ?? [] : [],
            generalNoteAttachments: getJob.generalNoteAttachments ? JSON.parse(getJob?.generalNoteAttachments ?? "[]")?.map((generalNoteAttachments, index) => {
                return {
                    uid: index + 1,
                    name: generalNoteAttachments?.split("/")?.pop()?.replace(/(%[0-9A-Fa-f]{2})+/g, "_") ?? "File",
                    status: 'done',
                    url: generalNoteAttachments,
                    response: generalNoteAttachments
                }
            }) ?? [] : [],
            logisticNoteAttachments: getJob.logisticNoteAttachments ? JSON.parse(getJob?.logisticNoteAttachments ?? "[]")?.map((logisticNoteAttachments, index) => {
                return {
                    uid: index + 1,
                    name: logisticNoteAttachments?.split("/")?.pop()?.replace(/(%[0-9A-Fa-f]{2})+/g, "_") ?? "File",
                    status: 'done',
                    url: logisticNoteAttachments,
                    response: logisticNoteAttachments
                }
            }) ?? [] : [],
            invoice: getJob.invoice ? JSON.parse(getJob?.invoice ?? "[]")?.map((invoice, index) => {
                return {
                    uid: index + 1,
                    name: invoice?.split("/")?.pop()?.replace(/(%[0-9A-Fa-f]{2})+/g, "_") ?? "File",
                    status: 'done',
                    url: invoice,
                    response: invoice
                }
            }) ?? [] : [],
        })
    }

    useEffect(() => {
        fetchMasters();
        if (jobId) {
            dispatch(getJobById(jobId, updateFields))
        }
    }, []);

    useEffect(() => {
        updateFollowupRequired(getJob.isFollowupReq ? "true" : "false");
    }, [getJob])

    useEffect(() => {
        if (!getJobLoading && isEdit) {
            updateFields();
        }
    }, [getJobLoading])

    useEffect(() => {
        form.setFieldsValue({ isFollowupReq: followUpReq })
    }, [followUpReq])

    useEffect(() => {
        if (sessionStorage.getItem('isUploading')?.toString() === '1' && !reload) {
            setReload(!reload);
        } else if (sessionStorage.getItem('isUploading')?.toString() === '0' && reload) {
            setReload(!reload);
        }
    }, [searchParams]);

    return <div>
        <PageHeader
            className="flex items-center justify-between bg-transparent [&>div>div>.ant-page-header-heading-title]:text-[22px] [&>div>div>.ant-page-header-heading-title]:font-semibold [&>div>div>.ant-page-header-heading-title]:text-dark dark:[&>div>div>.ant-page-header-heading-title]:text-white leading-[32px] [&>div>div]:flex [&>div>div]:items-center gap-[12px] [&>div]:flex [&>div]:flex-wrap [&>div]:items-center [&>div]:w-full [&>div]:gap-[10px] [&>div>.ant-page-header-heading-left]:m-0 [&>div>.ant-page-header-heading-left]:gap-[12px]"
            ghost
            title={isEdit ? `Edit Job (${getJob?.jobCode ?? "-"})` : "Add New Job"}
        />

        {isEdit && getJobLoading && <div className="w-full h-full flex mb-11 items-center justify-center">
            <div className="spin">
                <Spin />
            </div>
        </div>}

        {isEdit && getJobErr && <Alert message="Something went wrong, Unable to get Job." type="error" />}

        {(!getJobLoading || !isEdit) && <Card className=" mx-4 mb-4">
            <Form
                className=" px-4"
                layout="vertical"
                initialValues={getInitialState()}
                form={form}
                onFinish={handleSubmit}
            >
                <Row gutter={[15, 0]}>

                    {roleId !== 3 && <Col md={{ span: 6 }} xs={{ span: 24 }}>
                        <Form.Item label="Query Received On" name="queryReceivedOn">
                            <DatePicker disabledDate={(current) => current < moment().startOf('day')} className=" w-full h-12" />
                        </Form.Item>
                    </Col>}

                    {roleId !== 3 && <Col md={{ span: 6 }} xs={{ span: 24 }}>
                        <Form.Item label="Quotation Date" name="quotationDate">
                            <DatePicker disabledDate={(current) => current < moment().startOf('day')} className=" w-full h-12" />
                        </Form.Item>
                    </Col>}

                    <Col md={{ span: 6 }} xs={{ span: 24 }}>
                        <Form.Item label="Shipname" name="shipname" rules={[{ required: true }]}>
                            <Input disabled={roleId === 3} className="rounded-6" placeholder="Enter ship name" />
                        </Form.Item>
                    </Col>

                    {['https://jobs.thawe.ae', 'http://localhost:3000'].includes(window.location.origin) && <Col md={{ span: 6 }} xs={{ span: 24 }}>
                        <Form.Item label={
                            <div className="flex gap-2">
                                <Typography>Country</Typography>
                                {roleId !== 3 && <Button
                                    type="primary"
                                    size="small"
                                    shape="circle"
                                    tabIndex="-1"
                                    onClick={() => showModal(<AddEditCountries handleClose={handleOk} />, "Country")}
                                >+</Button>}
                            </div>} name="country_id">
                            <Select
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                                filterSort={(optionA, optionB) =>
                                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                }
                                className="[&>div]:px-[20px] [&>div]:bg-white dark:[&>div]:bg-white10 [&>div]:h-[50px] [&>div]:border-normal dark:[&>div]:border-white10 [&>div]:leading-[48px] [&>div]:rounded-6 [&>div>.ant-select-selection-item]:leading-[48px]"
                                placeholder="Please select country"
                                loading={country?.loading}
                                options={country?.data ?? []}
                            />
                        </Form.Item>
                    </Col>}

                    <Col md={{ span: 6 }} xs={{ span: 24 }}>
                        <Form.Item label={
                            <div className="flex gap-2">
                                <Typography>Company</Typography>
                                {roleId !== 3 && <Button
                                    type="primary"
                                    size="small"
                                    shape="circle"
                                    tabIndex="-1"
                                    onClick={() => showModal(<AddEditCompany handleClose={handleOk} />, "Company")}
                                >+</Button>}
                            </div>}
                            name="company" rules={[{ required: true }]} >
                            <Select
                                showSearch
                                disabled={roleId === 3}
                                optionFilterProp="children"
                                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                                filterSort={(optionA, optionB) =>
                                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                }
                                className="[&>div]:px-[20px] [&>div]:bg-white dark:[&>div]:bg-white10 [&>div]:h-[50px] [&>div]:border-normal dark:[&>div]:border-white10 [&>div]:leading-[48px] [&>div]:rounded-6 [&>div>.ant-select-selection-item]:leading-[48px]"
                                placeholder="Please select company"
                                loading={company?.loading}
                                options={company?.data ?? []}
                            />
                        </Form.Item>
                    </Col>

                    <Col md={{ span: 6 }} xs={{ span: 24 }}>
                        <Form.Item label={<div className="flex gap-2">
                            <Typography>Engineers</Typography>
                            {roleId !== 3 && <Button
                                type="primary"
                                size="small"
                                shape="circle"
                                tabIndex="-1"
                                onClick={() => showModal(<AddEditEngineer isVendorEng handleClose={handleOk} />, "Engineer")}
                            >+</Button>}
                        </div>} name="engineers">
                            <Select
                                showSearch
                                disabled={roleId === 3}
                                optionFilterProp="children"
                                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                                filterSort={(optionA, optionB) =>
                                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                }
                                className="[&>div]:py-[10px] [&>div]:border-normal dark:[&>div]:border-white10 [&>div]:rounded-6 [&>.ant-select-arrow]:text-theme-gray dark:[&>.ant-select-arrow]:text-white60 [&>div>div>div>span]:bg-transparent [&>div>div>div>span]:h-[26px] [&>div>div>div>span]:items-center"
                                placeholder="Please select engineers"
                                mode="multiple"
                                loading={engineers?.get_vendor_eng_loading}
                                options={engineers?.get_vendor_eng_data ?? []}
                            />
                        </Form.Item>
                    </Col>

                    <Col md={{ span: 6 }} xs={{ span: 24 }}>
                        <Form.Item label={
                            <div className="flex gap-2">
                                <Typography>Job Description</Typography>
                                {[1, 5].includes(roleId) && <Button
                                    type="primary"
                                    size="small"
                                    shape="circle"
                                    tabIndex="-1"
                                    onClick={() => showModal(<AddEditjobDescription handleClose={handleOk} />, "Job Description")}
                                >+</Button>}
                            </div>
                        } name="descriptions" rules={[{ required: true }]}>
                            <Select
                                showSearch
                                optionFilterProp="children"
                                disabled={roleId === 3}
                                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                                filterSort={(optionA, optionB) =>
                                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                }
                                className="[&>div]:py-[10px] [&>div]:border-normal dark:[&>div]:border-white10 [&>div]:rounded-6 [&>.ant-select-arrow]:text-theme-gray dark:[&>.ant-select-arrow]:text-white60 [&>div>div>div>span]:bg-transparent [&>div>div>div>span]:h-[26px] [&>div>div>div>span]:items-center"
                                placeholder="Please select descriptions"
                                mode="multiple"
                                loading={jobDescription?.loading}
                                options={jobDescription?.data ?? []}
                            />
                        </Form.Item>
                    </Col>

                    <Col md={{ span: 6 }} xs={{ span: 24 }}>
                        <Form.Item label="Target Port" name="targetPort">
                            <Input disabled={roleId === 3} className="rounded-6" placeholder="Enter target port" />
                        </Form.Item>
                    </Col>

                    <Col md={{ span: 6 }} xs={{ span: 24 }}>
                        <Form.Item label="Vessel ETA" name="vesselETA">
                            <DatePicker disabled={roleId === 3} disabledDate={(current) => current < moment().startOf('day')} className=" w-full h-12" />
                        </Form.Item>
                    </Col>

                    {isEdit && <>
                        {roleId !== 3 && <Col md={{ span: 6 }} xs={{ span: 24 }}>
                            <Form.Item label="Is Reminder Sent?" name="setReminder" valuePropName="checked">
                                <Checkbox>Sent Reminder</Checkbox>
                            </Form.Item>
                        </Col>}
                    </>}

                    {(isEdit || quotationDate) && roleId !== 3 && <Col md={{ span: 6 }} xs={{ span: 24 }}>
                        <Form.Item label="P.O Number" name="poNumber" rules={[{ required: isJobCompleted }]}>
                            <Input className="rounded-6" placeholder="Enter P.O Number" />
                        </Form.Item>
                    </Col>}

                    <Col md={{ span: 12 }} xs={{ span: 24 }}>
                        <Form.Item label="Description" name="description">
                            <Input.TextArea rows={4} disabled={roleId === 3} className="rounded-6" placeholder="Enter description" />
                        </Form.Item>
                    </Col>

                    {(isEdit || poNumber) && <>
                        <Col md={{ span: 12 }} xs={{ span: 24 }}>
                            <Form.Item label="Spares" name="spares">
                                <Input className="rounded-6" placeholder="Enter spares" />
                            </Form.Item>

                            {false && <Form.Item label={
                                <div className="flex gap-2">
                                    <Typography>Spares</Typography>
                                    {roleId !== 3 && <Button
                                        type="primary"
                                        size="small"
                                        shape="circle"
                                        tabIndex="-1"
                                        onClick={() => showModal(<AddEditSpares handleClose={handleOk} />, "Spare")}
                                    >+</Button>}
                                </div>
                            } name="spares">
                                <Select
                                    showSearch
                                    disabled={roleId === 3}
                                    optionFilterProp="children"
                                    filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                                    filterSort={(optionA, optionB) =>
                                        (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                    }
                                    className="[&>div]:py-[10px] [&>div]:border-normal dark:[&>div]:border-white10 [&>div]:rounded-6 [&>.ant-select-arrow]:text-theme-gray dark:[&>.ant-select-arrow]:text-white60 [&>div>div>div>span]:bg-transparent [&>div>div>div>span]:h-[26px] [&>div>div>div>span]:items-center"
                                    placeholder="Please select spares"
                                    mode="multiple"
                                    loading={spares?.loading}
                                    options={spares?.data ?? []}
                                />
                            </Form.Item>}
                        </Col>

                        <Col md={{ span: 6 }} xs={{ span: 24 }}>
                            <Form.Item label={
                                <div className="flex gap-2">
                                    <Typography>Agents</Typography>
                                    {roleId !== 3 && <Button
                                        type="primary"
                                        size="small"
                                        shape="circle"
                                        tabIndex="-1"
                                        onClick={() => showModal(<AddEditAgents handleClose={handleOk} />, "Agent")}
                                    >+</Button>}
                                </div>
                            } name="agents">
                                <Select
                                    showSearch
                                    disabled={roleId === 3}
                                    optionFilterProp="children"
                                    filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                                    filterSort={(optionA, optionB) =>
                                        (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                    }
                                    className="[&>div]:px-[20px] [&>div]:bg-white dark:[&>div]:bg-white10 [&>div]:h-[50px] [&>div]:border-normal dark:[&>div]:border-white10 [&>div]:leading-[48px] [&>div]:rounded-6 [&>div>.ant-select-selection-item]:leading-[48px]"
                                    placeholder="Please select agent"
                                    loading={agents?.loading}
                                    options={agents?.data ?? []}
                                />
                            </Form.Item>
                        </Col>

                        {roleId !== 3 && <Col md={{ span: 6 }} xs={{ span: 24 }}>
                            <Form.Item label="Mark Job Completed" name="isJobCompleted" valuePropName="checked">
                                <Checkbox>Job Completed</Checkbox>
                            </Form.Item>
                        </Col>}

                        {roleId !== 3 && <Col md={{ span: 6 }} xs={{ span: 24 }}>
                            <Form.Item label="Completion Date" name="completionDate">
                                <DatePicker disabledDate={(current) => current < moment().startOf('day')} className=" w-full h-12" />
                            </Form.Item>
                        </Col>}

                    </>}

                    {(isEdit || isJobCompleted) && roleId !== 3 && <Col span={24}>
                        <Form.Item label="Is Service Report Sent?" name="isServiceReportSent" valuePropName="checked">
                            <Checkbox>Service Report Sent</Checkbox>
                        </Form.Item>
                    </Col>}
                    {isEdit && <Col md={{ span: 6 }} xs={{ span: 24 }}>
                        <Form.Item label="Is Spare need to Prepare?" name="spareVerified" valuePropName="checked">
                            <Checkbox disabled={roleId === 3}>Need to Prepare</Checkbox>
                        </Form.Item>
                    </Col>}

                    {isEdit && <Col md={{ span: 6 }} xs={{ span: 24 }}>
                        <Form.Item label="Is Spare Prepared?" name="sparePrepare" valuePropName="checked">
                            <Checkbox disabled={roleId === 3}>Prepared</Checkbox>
                        </Form.Item>
                    </Col>}


                    {(isEdit || poNumber) && roleId !== 3 && <Col md={{ span: 6 }} xs={{ span: 24 }}>
                        <Form.Item label="Invoice Date" name="invoiceDate">
                            <DatePicker disabledDate={(current) => current < moment().startOf('day')} className=" w-full h-12" />
                        </Form.Item>
                    </Col>}

                    {(isEdit || poNumber) && roleId !== 3 && <Col span={24}>
                        <Form.Item label="Invoice Document">
                            <Form.Item name="invoice" valuePropName="fileList" getValueFromEvent={normFile} noStyle>
                                <Upload.Dragger multiple listType="picture" customRequest={onFileUpload} >
                                    <p className="ant-upload-drag-icon">
                                        <InboxOutlined />
                                    </p>
                                    <p>Click or drag file to this area to upload</p>
                                </Upload.Dragger>
                            </Form.Item>
                        </Form.Item>
                    </Col>}

                    {isEdit && <>
                        {roleId !== 3 && <Col md={{ span: 6 }} xs={{ span: 24 }}>
                            <Form.Item label="Vessel Class" name="boxVesselClass">
                                <Input className="rounded-6" placeholder="Enter vessel class" />
                            </Form.Item>
                        </Col>}

                        {roleId !== 3 && <Col md={{ span: 6 }} xs={{ span: 24 }}>
                            <Form.Item label="Equipment Detail" name="equipmentDetail">
                                <Input className="rounded-6" placeholder="Enter equipment detail" />
                            </Form.Item>
                        </Col>}

                        {roleId !== 3 && <Col md={{ span: 6 }} xs={{ span: 24 }}>
                            <Form.Item label="Equipment Model" name="equipmentModal">
                                <Input className="rounded-6" placeholder="Enter Equipment Model" />
                            </Form.Item>
                        </Col>}

                        {roleId !== 3 && <Col md={{ span: 12 }} xs={{ span: 24 }}>
                            <Form.Item label="General Note" name="generalNote">
                                <Input.TextArea rows={4} className="rounded-6" placeholder="Enter notes" />
                            </Form.Item>
                        </Col>}

                        {roleId !== 3 && <Col md={{ span: 12 }} xs={{ span: 24 }}>
                            <Form.Item label="General Note Attachments">
                                <Form.Item name="generalNoteAttachments" valuePropName="fileList" getValueFromEvent={normFile} noStyle>
                                    <Upload.Dragger multiple listType="picture" customRequest={onFileUpload} >
                                        <p className="ant-upload-drag-icon">
                                            <InboxOutlined />
                                        </p>
                                        <p>Click or drag to this area to upload</p>
                                    </Upload.Dragger>
                                </Form.Item>
                            </Form.Item>
                        </Col>}

                        <Col md={{ span: 12 }} xs={{ span: 24 }}>
                            <Form.Item label="Note to Engineer" name="engineerNote">
                                <Input.TextArea rows={4} className="rounded-6" disabled={roleId === 3} placeholder="Enter notes" />
                            </Form.Item>
                        </Col>

                        <Col md={{ span: 12 }} xs={{ span: 24 }}>
                            <Form.Item label="Engineer Note Attachments">
                                <Form.Item name="engineerNoteAttachments" valuePropName="fileList" getValueFromEvent={normFile} noStyle>
                                    <Upload.Dragger multiple listType="picture" customRequest={onFileUpload} >
                                        <p className="ant-upload-drag-icon">
                                            <InboxOutlined />
                                        </p>
                                        <p>Click or drag to this area to upload</p>
                                    </Upload.Dragger>
                                </Form.Item>
                            </Form.Item>
                        </Col>

                        {[1, 5, 6].includes(roleId) && logisticCondition.includes(getJob?.targetPort ?? "") && <Col md={{ span: 12 }} xs={{ span: 24 }}>
                            <Form.Item label="Logistic Note" name="logisticNote">
                                <Input.TextArea rows={4} className="rounded-6" disabled={roleId === 3} placeholder="Enter notes" />
                            </Form.Item>
                        </Col>}

                        {[1, 5, 6].includes(roleId) && logisticCondition.includes(getJob?.targetPort ?? "") && <Col md={{ span: 12 }} xs={{ span: 24 }}>
                            <Form.Item label="Logistic Reports">
                                <Form.Item name="logisticNoteAttachments" valuePropName="fileList" getValueFromEvent={normFile} noStyle>
                                    <Upload.Dragger multiple listType="picture" customRequest={onFileUpload} >
                                        <p className="ant-upload-drag-icon">
                                            <InboxOutlined />
                                        </p>
                                        <p>Click or drag to this area to upload</p>
                                    </Upload.Dragger>
                                </Form.Item>
                            </Form.Item>
                        </Col>}
                    </>}

                    {(isEdit || poNumber) && roleId !== 3 && <Col span={24}>
                        <Form.Item label="Is Follow Up Required?" name="isFollowupReq">
                            <Radio.Group value={followUpReq} onChange={(e) => updateFollowupRequired(e.target.value)}>
                                <Radio.Button value="true">Yes</Radio.Button>
                                <Radio.Button value="false">No</Radio.Button>
                            </Radio.Group>
                        </Form.Item>
                    </Col>}

                    {(followUpReq === "true") && roleId !== 3 && <Col md={{ span: 6 }} xs={{ span: 24 }}>
                        <Form.Item label="Next Attend Date" name="nextAttendDate">
                            <DatePicker disabledDate={(current) => current < moment().startOf('day')} className=" w-full h-12" />
                        </Form.Item>
                    </Col>}

                    {isEdit && <>

                        <Col span={24}>
                            <Form.Item label="Service Report">
                                <Form.Item name="serviceReport" valuePropName="fileList" getValueFromEvent={normFile} noStyle>
                                    <Upload.Dragger multiple listType="picture" customRequest={onFileUpload} >
                                        <p className="ant-upload-drag-icon">
                                            <InboxOutlined />
                                        </p>
                                        <p>Click or drag file to this area to upload</p>
                                    </Upload.Dragger>
                                </Form.Item>
                            </Form.Item>
                        </Col>
                        {state?.showVDRCOC && <Col span={24}>
                            <Form.Item label="VDR COC">
                                <Form.Item name="vdcCocReport" valuePropName="fileList" getValueFromEvent={normFile} noStyle>
                                    <Upload.Dragger multiple listType="picture" customRequest={onFileUpload} >
                                        <p className="ant-upload-drag-icon">
                                            <InboxOutlined />
                                        </p>
                                        <p>Click or drag VDR COC to this area to upload</p>
                                    </Upload.Dragger>
                                </Form.Item>
                            </Form.Item>
                        </Col>}
                    </>}

                    {error && <Col md={{ span: 12 }} xs={{ span: 24 }}>
                        <Alert message="Something went wrong, Unable to proceed." type="error" />
                    </Col>}

                    <Col span={24}>
                        <Form.Item>
                            <div className="flex justify-between">
                                <div>
                                    {isEdit && roleId !== 3 && getJob.status !== 5 && <Button
                                        type="primary"
                                        loading={cancelJobLoading}
                                        onClick={onCancelJob}
                                        className="bg-warning hover:bg-warning-hover h-[38px] px-[22px] text-[15px] text-white dark:text-white87 font-normal border-warning"
                                    >
                                        Cancel Job
                                    </Button>}
                                </div>
                                <div className="flex items-center min-md:justify-end justify-center mt-[15px] gap-4">
                                    <Button
                                        className="bg-regularBG dark:bg-regularBGdark h-[38px] px-[22px] text-[15px] text-body dark:text-white60 hover:text-light font-normal border-regular dark:border-white10"
                                        onClick={() => {
                                            if (sessionStorage.getItem('isUploading')?.toString() === '1') {
                                                notification.warning({
                                                    message: "File upload in progress, please wait."
                                                })
                                            } else {
                                                form.resetFields();
                                                navigate(-1);
                                            }
                                        }}
                                    >
                                        Close
                                    </Button>
                                    <Button
                                        htmlType="submit"
                                        type="primary"
                                        loading={loading}
                                        disabled={cancelJobLoading}
                                        className="bg-primary hover:bg-primary-hover h-[38px] px-[22px] text-[15px] text-white dark:text-white87 font-normal border-primary"
                                    >
                                        {isEdit ? "Update" : "Create"}
                                    </Button>
                                </div>
                            </div>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Card>}

        {modal.open && (
            <Modal
                footer={[]}
                title={`Add ${modal.variant}`}
                open={modal.open}
                onOk={handleOk}
                onCancel={handleCancel}
            >
                {modal.component}
            </Modal>
        )}
    </div>
}

export default memo(AddEditJob)
